import './setWebpackPublicPath';
import App from './App.vue';
import AppJS from './AppJS.vue';
import router from './routing/Router'
import store from './store/GlobalStore'
import './registerServiceWorker'
import { AuthClient, Configuration } from "./api/ApiClientBase";
import * as ribbonFunctions from "../src/components/pages/excel/RibbonFunctions";
import { createApp } from 'vue'
import PortalVue from 'portal-vue';
import { JsPlumbToolkitVue2Plugin } from 'jsplumbtoolkit-vue2';
// @ts-ignore
import Toast from "vue-toastification";
import UiComponents from 'uicomponents';
// @ts-ignore
import cronLight from '@vue-js-cron/light';
// @ts-ignore
import Vue3Sanitize from "vue-3-sanitize";
import { initTraceIdInterceptor } from './utils/TraceIdInterceptor';
import { isEmbedded } from './utils/Utils';
import { initializeTelemetry } from '@/otel-setup';
import { getApolloClient, setGraphqlUri } from './apollo';
import { DefaultApolloClient } from '@vue/apollo-composable';
import PrimeVue from "primevue/config";
import Timeline from "primevue/timeline";
import "primevue/resources/themes/saga-blue/theme.css"; // or any theme
import "primevue/resources/primevue.min.css";
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import * as appShellClient from '@springboard/app-shell-client';
import { SecurityClient } from './api/ApiClient';
import { detectBasePath, resolveWithBase } from './utils/pathUtils';
import AppRouterLink from './components/helpers/AppRouterLink.vue';
import { createPinia } from 'pinia';

const start = async function () {
    window.localStorage.removeItem("Excel");
    const configUrl = resolveWithBase('config.json');
    var response = await fetch(configUrl);
    var json = await response.json();

    // Initialize trace-id interceptor, excluding Auth0 domains to avoid CORS issues.
    // Includes both the default auth0.com domain and any custom Auth0 domain from config.
    const traceIdExcludedDomains = [];
    if (json.auth0?.domain) {
        traceIdExcludedDomains.push(json.auth0.domain);
    }
    initTraceIdInterceptor(traceIdExcludedDomains);

    // ?? Initialize AppInsights Telemetry
    initializeTelemetry({
        instrumentationKey: json.appInsightsKey || '7191b8ef-3516-4a87-af3c-0776addefefe', // ensure you have it in config.json!
        environment: json.environment || 'development',
        version: json.version || '1.0.0',
        cloudRolename: json.appInsightsPortalRoleName || 'Portal',
    });

    if (json.hideWhatsNew == "false")
        json.hideWhatsNew = false;
    if (json.hideWhatsNew == "true")
        json.hideWhatsNew = true;


    AuthClient.configuration.apiBaseUrl = json.apiBaseUrl;
    AuthClient.configuration.apiBaseUrl_dev = json.apiBaseUrl_dev;
    AuthClient.configuration.apiProxy_url = json.apiProxy_url;
    AuthClient.configuration.environment = json.environment;
    AuthClient.configuration.$config = json;

    if (isEmbedded()) {
        AuthClient.isAnaplanLogin = true;
        AuthClient.configuration.apiBaseUrl = AuthClient.configuration.apiProxy_url;
        await appShellClient.hideGNavQuickLinks(true);
        await appShellClient.updateGNavDefaultProduct(appShellClient.NavProduct.FINANCIAL_CLOSE_AND_CONSOLIDATION)
        await appShellClient.setLoginRedirectCallback(async() => {
            let authClient = AuthClient.getInstance();
            let securityClient = new SecurityClient(authClient);
            await securityClient.logout();
        });
    }

    document.title = AuthClient.configuration.$config?.portalTitle ?? "FCR | Anaplan";

    var isExcel = window.localStorage.getItem("Excel");
    if (document.URL.indexOf("fluencejs") > 0 || isExcel) {
        window.localStorage.setItem("Excel", "Excel");

        AuthClient.configuration.environment = "officejs";

        var script = document.createElement('script');
        //script.src = "https://appsforoffice.microsoft.com/lib/1/hosted/office.js";
        script.src = "https://appsforoffice.microsoft.com/lib/beta/hosted/office.js";

        script.onload = function () {
            (window as any).Office.initialize = () => {
                const app = createApp(AppJS);

                app.use(PortalVue);
                app.use(store);
                app.use(router);
                app.use(Toast, {
                    transition: "Vue-Toastification__bounce",
                    maxToasts: 20,
                    newestOnTop: true
                });
                let defaults = Vue3Sanitize.defaults;
                defaults.allowedTags.push('img');
                defaults.allowedSchemes.push('data');
                const overridenOptions = JSON.parse(JSON.stringify(defaults));
                app.use(Vue3Sanitize, overridenOptions);

                router.isReady().then(() => app.mount('#app'));
            }
            function getGlobal() {
                return typeof self !== "undefined"
                    ? self
                    : typeof window !== "undefined"
                        ? window
                        : typeof global !== "undefined"
                            ? global
                            : undefined;
            }

            const g = getGlobal() as any;

            g.ShowTaskpane = ribbonFunctions.ShowTaskpane;
        };

        document.head.appendChild(script);
    }
    else {
        const app = createApp(App);

        app.use(PortalVue);
        app.use(store);
        app.use(router);
        app.use(cronLight);
        // @ts-ignore
        app.use(JsPlumbToolkitVue2Plugin)
        app.use(Toast, {
            transition: "Vue-Toastification__bounce",
            maxToasts: 20,
            newestOnTop: true
        });
        app.use(UiComponents);

         // LaunchDarkly Plugin
        
        if (json.launchDarkly?.clientSideID) {
            app.use(LDPlugin, {
                clientSideID: json.launchDarkly.clientSideID,
                context: {
                    kind: 'user',
                    key: 'fccr',
                }
            });
        }

        let defaults = Vue3Sanitize.defaults;
        defaults.allowedTags.push('img');
        defaults.allowedSchemes.push('data');
        defaults.allowedAttributes["img"] = ['src', 'srcset', 'alt', 'title', 'loading'];
        defaults.allowedClasses = {
            '*': ['whatsnewtable']
        }
        setGraphqlUri(`${AuthClient.configuration.apiBaseUrl}/graphql`);
        const overridenOptions = JSON.parse(JSON.stringify(defaults));
        app.use(Vue3Sanitize, overridenOptions);
        app.provide(DefaultApolloClient, getApolloClient());
        app.use(PrimeVue);
        app.component("Timeline", Timeline);
        app.component("RouterLink", AppRouterLink);

        const pinia = createPinia();
        app.use(pinia);

        router.isReady().then(() => app.mount('#app'));
    }
};

await start();